<template>
    <div class="hdl-search">
        <div class="search-box">
            <div class="searchwapper clearfix">
                <div class="searchTitle">
                    <span>Handle标识查询</span>
                </div>
                <div class="searchInput clearfix">
                    <form id="fromhdl" :action="formUrl" method="post" @submit.prevent="noSubmit">
                        <input type="text" id="hdl" name="hdl" v-model="hdl" placeholder="请输入有效Handle标识..." />
                        <button type="submit">检索</button>
                        <span class="errorWarn" v-if="warnShow">请输入有效的Handle查询码</span>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'HandleSearch',
  data () {
    return {
      formUrl: 'https://hdl.cndona.net',
      hdl: '',
      warnShow: false
    }
  },
  watch: {
    hdl () {
      if (this.hdl !== '') this.warnShow = false
    }
  },
  methods: {
    noSubmit () {
      const from = document.getElementById('fromhdl')
      if (this.hdl !== '') {
        from.submit()
        return true
      } else {
        this.warnShow = true
        return false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.hdl-search{
    width: 100%;
    height: 270px;
    border-bottom: 1px solid #f2f2f2;
    background:#f4faff url('./../../assets/img/products/mpaLogo.png') no-repeat center top;
    background-position: 50% 50%;
    .searchwapper{
      margin: 0 auto;
      padding: 50px 0;
      width: 800px;
      .searchTitle{
        font-size: 18px;
        line-height: 40px;
        width: 100%;
        text-align: center;
        margin: 30px 0 20px;
        span {
          display: block;
          font-size: 36px;
          text-align: center;
          color: #0b428b;
          font-weight: bold;
        }
        // span:nth-child(2) {
        //   font-size: 16px;
        //   line-height: 40px;
        //   font-style: normal;
        //   font-weight: 500;
        //   color: #909090;
        // }
      }
      .searchInput{
        float: left;
        width: calc(100% - 50px);
        input {
            float: left;
            margin: 0;
            padding: 3px 12px;
            width: calc(100% - 80px);
            height: 52px;
            cursor: text;
            outline: none;
            font-size: 16px;
            color: #4c4c4c;
            border: 1px solid #3e91ff;
            border-top-left-radius: 10px;
            border-bottom-left-radius: 10px;
        }
        input::placeholder {
            font-size: 15px;
            color: #59b4ff;
        }
        button {
            float: left;
            margin: 0;
            width: calc(80px);
            height: 52px;
            border: none;
            background-color: #3e91ff;
            color: #fff;
            cursor: pointer;
            outline: none;
            border-top-right-radius: 10px;
            border-bottom-right-radius: 10px;
        }
        button:hover {
            background-color: #e6a237;
        }
        .errorWarn{
            display: block;
            float: left;
            color: red;
            font-size:14px;
            margin-top:3px;
        }
      }
    }
}
@media screen and (max-width: 1000px) {
.hdl-search{
  padding: 0;
  .searchwapper {
    padding: 50px 10px;
    width: 100%;
    .searchTitle{
      float: none;
    }
    .searchInput{
      float: none;
      width: 100%;
    }
  }
}
}
</style>



// WEBPACK FOOTER //
// src/Home/components/HandleSearch.vue